/**
 * The booking forms on file for a sale, as the sale detail shows them.
 *
 * `sale.booking_forms` comes from the agent server, one entry per form linked by
 * `booking_forms.sale_id`: `{ id, form_ref, kind, status, mine }`. `kind` is
 * derived server-side from (form_type, sale_type), never from the ref: 82 legacy
 * agreement letters carry an `ALR…` ref.
 *
 *  - ATP / ATR: the agreement letter (CID issues it as OTP / OTR). HQ and the
 *    undertaking letters call its number the "ATP / ATR no.", so that is the label.
 *  - ALS / ALR: an authorisation letter — a different paper, shown on its own row.
 *
 * `mine` is whether the forms screen will open it for this agent: it only serves
 * the forms the agent wrote, so a co-agent's form is shown but not linked.
 * `booking_forms` is null when the server could not read them, which is not the
 * same as "none".
 */
export function splitLinkedForms(forms) {
  const list = forms || [];
  return {
    agreements: list.filter((f) => f.kind === 'ATP' || f.kind === 'ATR'),
    authorisations: list.filter((f) => f.kind === 'ALS' || f.kind === 'ALR'),
  };
}

/** "ATR no." on a rental, "ATP no." otherwise — the paper this deal type issues. */
export const agreementLabel = (isRent) => (isRent ? 'ATR no.' : 'ATP no.');
